import { createContext, useContext } from 'react';
const MagicBellContext = createContext({});
export default MagicBellContext;
const useMagicBellContext = () => useContext(MagicBellContext);
export { useMagicBellContext };
//# sourceMappingURL=MagicBellContext.js.map